import { render } from "./ProspectAppsDetails.vue?vue&type=template&id=286fb09f"
import script from "./ProspectAppsDetails.vue?vue&type=script&lang=js"
export * from "./ProspectAppsDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__